import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async addBenefitToClaim(variables) {
		const res = await gql({
			query: mutation.addBenefitToClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addBenefitToClaim"
		})
	},

	async removeBenefitFromClaim(variables) {
		const res = await gql({
			query: mutation.removeBenefitFromClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeBenefitFromClaim"
		})
	},

	async updateBenefitClaim(variables) {
		const res = await gql({
			query: mutation.updateBenefitClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateBenefitClaim"
		})
	},

	async createClaim(variables) {
		const res = await gql({
			query: mutation.createClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createClaim"
		})
	},

	async updateClaim(variables) {
		const res = await gql({
			query: mutation.updateClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateClaim"
		})
	},

	async deleteClaim(variables) {
		const res = await gql({
			query: mutation.deleteClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteClaim"
		})
	},

	async listClaims(variables) {
		if (!variables.where) variables.where = {}

		const res = await gql({
			query: query.listClaims,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	// find policy
	async findPolicy(variables) {
		const res = await gql({
			query: query.findPolicy,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	// policy details
	async findPolicyDetails(variables) {
		const res = await gql({
			query: query.findPolicyDetails,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	// pdf templates
	async pdfTemplates(variables) {
		const res = await gql({
			query: query.pdfTemplates,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "templates"
		})
	},

	async pdfDrawingQuery(variables) {
		const res = await gql({
			query: query.pdfDrawingQuery,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "renderPdfDrawingTemplate"
		})
	},

	async wkhtmltopdfQuery(variables) {
		const res = await gql({
			query: query.wkhtmltopdfQuery,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "renderWkhtmltopdfTemplate"
		})
	},

	// Facts templates
	async factsTemplates(variables) {
		const res = await gql({
			query: query.factsTemplates,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "claimFactTemplates"
		})
	},

	async claim(variables) {
		const res = await gql({
			query: query.claim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async benefitClaimsAndBalance(variables) {
		const res = await gql({
			query: query.benefitClaimsAndBalance,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async benefitGraph(variables) {
		const res = await gql({
			query: query.benefitGraph,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async claimSummary(variables) {
		const res = await gql({
			query: query.claimSummary,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async addFactToClaim(variables) {
		const res = await gql({
			query: mutation.addFactToClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addFactToClaim"
		})
	},

	async removeFactFromClaim(variables) {
		const res = await gql({
			query: mutation.removeFactFromClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeFactFromClaim"
		})
	},

	async updateClaimFact(variables) {
		const res = await gql({
			query: mutation.updateClaimFact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateClaimFact"
		})
	},

	async claimLogs(variables) {
		const res = await gql({
			query: query.claimLogs,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async claimFiles(variables) {
		const res = await gql({
			query: query.claimFiles,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "fileListing"
		})
	},

	async claimTransactions(variables) {
		const res = await gql({
			query: query.claimTransactions,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "claims"
		})
	},

	async addTransaction(variables) {
		const res = await gql({
			query: mutation.addTransaction,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createTransaction"
		})
	},

	async updateTransaction(variables) {
		const res = await gql({
			query: mutation.updateTransaction,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateTransaction"
		})
	},

	async claimRejectionSettings(variables) {
		const res = await gql({
			query: query.claimRejectionSettings,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async generalCodes(variables) {
		const res = await gql({
			query: query.generalCodes,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products"
		})
	},

	async rejectClaim(variables) {
		const res = await gql({
			query: mutation.rejectClaim,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "rejectClaim"
		})
	}
}
